<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 220px">
        <p>委托商：</p>
        <el-input v-model="unitIpt" size="mini" style="width: 150px" placeholder="请输入委托商" />
      </div>
      <div class="navContainer" style="width: 220px">
        <p>供应商：</p>
        <el-input v-model="supplier" size="mini" style="width: 150px" placeholder="请输入供应商" />
      </div>
      <div class="navContainer" style="width: 220px">
        <p>批次号：</p>
        <el-input
          v-model="batchIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入批次号"
          @paste.native.capture.prevent="
            value => {
              return searchCopyFormat(value, 'batchIpt');
            }
          " />
      </div>
      <div class="navContainer" style="width: 220px">
        <p>运单号：</p>
        <el-input
          v-model="awbIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入运单号"
          @paste.native.capture.prevent="
            value => {
              return searchCopyFormat(value, 'awbIpt');
            }
          " />
      </div>
      <div class="navContainer" style="width: 220px">
        <p>车架号：</p>
        <el-input
          v-model="chassisIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入底盘号"
          @paste.native.capture.prevent="
            value => {
              return searchCopyFormat(value, 'chassisIpt');
            }
          " />
      </div>
      <div class="navContainer" style="width: 220px">
        <p>船舶名称：</p>
        <el-input v-model="shipName" size="mini" style="width: 150px" placeholder="请输入船舶名称" />
      </div>
      <div class="navContainer" style="width: 220px">
        <p>品牌：</p>
        <el-input v-model="brandIpt" size="mini" style="width: 150px" placeholder="请输入品牌" />
      </div>
      <div class="navContainer" style="width: 220px">
        <p>航次：</p>
        <el-input v-model="voyageNumber" size="mini" style="width: 150px" placeholder="请输入航次" />
      </div>
      <div class="navContainer" style="width: 220px">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width: 150px" placeholder="请选择">
          <el-option v-for="item in areaOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 420px">
        <p style="width: 80px">计划时间：</p>
        <el-date-picker v-model="planDate" type="daterange" size="mini" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" />
      </div>
      <div class="navContainer" style="width: 420px">
        <p style="width: 80px">装车时间：</p>
        <el-date-picker v-model="loadingDate" type="daterange" size="mini" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span @click="exportData">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table v-loading="tableLoad" :data="TableDatas" style="width: 100%" border stripe :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', height: '48px', background: '#E8E8E8' }" :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }">
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column prop="consignorName" label="委托商" min-width="120" align="center" />
          <el-table-column prop="batchNumber" label="批次号" min-width="160" align="center" />
          <el-table-column prop="waybillNo" label="运单号" min-width="150" align="center" />
          <el-table-column prop="frameNumber" label="车架号" width="150" align="center" />
          <el-table-column prop="brandName" label="品牌" align="center" />
          <el-table-column prop="modelName" label="型号" align="center" />
          <el-table-column prop="transportMode" label="运输方式" align="center" :formatter="transportModeExportFormat" />
          <el-table-column prop="departurePlace" label="起始地" min-width="150" :formatter="getStart" align="center" />
          <el-table-column prop="departurePort" label="起始港" align="center" />
          <el-table-column prop="arrivePort" label="目的港" align="center" />
          <el-table-column prop="arrivePlace" label="交车地" min-width="150" :formatter="getEnd" align="center" />
          <el-table-column prop="planDate" label="计划时间" align="center" :formatter="dateFormat" />
          <el-table-column prop="actualPositionName" label="当前位置" min-width="150" :formatter="getActual" align="center" />
          <el-table-column label="状态" align="center">
            <div slot-scope="scope">{{ getState(scope.row.state) }}</div>
          </el-table-column>
          <div v-for="(item, index) in brand" :key="index">
            <el-table-column :prop="`transport${index + 1}`" :label="`运输工具${index + 1}`" width="150" align="center" :formatter="formatValue" />
            <el-table-column :prop="`transportType${index + 1}`" :label="`运输方式${index + 1}`" width="150" align="center" :formatter="formatValue" />
            <el-table-column :prop="`loadingDate${index + 1}`" :label="`装车时间${index + 1}`" width="150" align="center" :formatter="formatValue" />
            <el-table-column :prop="`deliveryDate${index + 1}`" :label="`交车时间${index + 1}`" width="150" align="center" :formatter="formatValue" />
            <el-table-column :prop="`supplierName${index + 1}`" :label="`供应商${index + 1}`" width="150" align="center" :formatter="formatValue" />
            <el-table-column :prop="`loadingPlace${index + 1}`" :label="`装车地${index + 1}`" width="150" align="center" :formatter="formatValue" />
            <el-table-column :prop="`deliveryPlace${index + 1}`" :label="`交车地${index + 1}`" width="150" align="center" :formatter="formatValue" />
            <el-table-column :prop="`lighterShipName${index + 1}`" :label="`过驳船名${index + 1}`" width="150" align="center" :formatter="formatValue" />
            <el-table-column :prop="`changeShipName${index + 1}`" :label="`转船船名${index + 1}`" width="150" align="center" :formatter="formatValue" />
          </div>
          <el-table-column label="操作" fixed="right" width="170" align="center">
            <template slot-scope="scope">
              <div style="align-items: center">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情 </el-button>
                <el-button size="mini" type="primary" @click="routeMapClick(scope.row.id)" class="yellow-bg">地图跟踪 </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog title="详情托运车信息" :visible.sync="detailDialogVisible" width="800px" center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">批次号：</span>
                <span>{{ detailData.batchNumber }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">运单号：</span>
                <span>{{ detailData.waybillNo }}</span>
              </div>
              <div>
                <span class="span1">底盘号：</span>
                <span>{{ detailData.frameNumber }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">车型：</span>
                <span>{{ detailData.modelName }}</span>
              </div>
              <div>
                <span class="span1">品牌：</span>
                <span>{{ detailData.brandName }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">起运地：</span>
                <span>{{ detailData.departurePlace ? detailData.departurePlace : '-' }}</span>
              </div>
              <div>
                <span class="span1">交车地：</span>
                <span>{{ detailData.arrivePlace ? detailData.arrivePlace : '-' }}</span>
              </div>
            </div>
            <!-- <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">起止单位：</span>
                <span>{{detailData.startingName?detailData.startingName:'-'}}</span>
              </div>
              <div>
                <span class="span1">交车单位：</span>
                <span>{{detailData.deliveryName?detailData.deliveryName:'-'}}</span>
              </div>
            </div> -->
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>运输路线</span>
          </div>
          <div class="stepContainer">
            <el-steps direction="vertical" space="50px">
              <el-step v-for="item in detailData.objectDate" :key="item.id">
                <div slot="title" style="width: 80%; display: flex; align-items: center; justify-content: space-between">
                  <span style="color: #282727">{{ `${item.loadingPlace} —— ${item.deliveryPlace}` }}</span>
                </div>
                <div slot="description" style="color: #6a6969">
                  <span>{{ `${item.loadingDate} —— ${item.deliveryDate}` }}</span>
                </div>
              </el-step>
            </el-steps>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="850px" center :close-on-click-modal="false">
      <div class="company" style="height: 700px">
        <!-- 放地图 -->
        <route-map :center="center" :line-arr="lineArr" v-if="dialogVisible"></route-map>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { vehicleDeployInfoCvCarList, vehicleDeployInfoCvCarDetail, EntrustedTrackingGetJWtitud } from '@/service/vehiclelog';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import popup from '@/components/popup';
  import routeMap from '@/components/routeMap';
  import { baseUrl } from '@/config/env';

  export default {
    components: {
      popup,
      routeMap,
    },
    data() {
      return {
        awbIpt: '',
        batchIpt: '',
        chassisIpt: '',
        unitIpt: '',
        supplier: '',
        brandIpt: '',
        shipName: '',
        voyageNumber: '',
        stateIpt: '',
        routerMap: {},
        areaOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待分配运输',
          },
          {
            value: 1,
            label: '已分配运输',
          },
          {
            value: 2,
            label: '运输中',
          },
          {
            value: 3,
            label: '已交车',
          },
          {
            value: 4,
            label: '其他',
          },
        ],
        center: '', //委托车当前位置
        lineArr: '', //委托车路线
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {},
        operationData: [],
        dialogTitle: '',
        dialogVisible: false,
        brand: [],
        planDate: ['', ''],
        loadingDate: ['', ''],
      };
    },
    computed: {
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
        };
      },
      getType() {
        return function (state) {
          switch (state) {
            case 1:
              return '委托商';
            case 2:
              return '经销商';
            case 3:
              return '仓库';
            case 4:
              return '港口及其它';
          }
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待分配运输';
            case 1:
              return '已分配运输';
            case 2:
              return '运输中';
            case 3:
              return '已交车';
            default:
              return '其他';
          }
        };
      },
      getStyle() {
        return val => {
          switch (val) {
            case 0:
              return 'color:#F56C6C;';
            case 1:
              return 'color: rgba(249, 166, 6, 1)';
            case 2:
              return 'color: rgba(51, 136, 255, 1)';
          }
        };
      },
    },
    mounted() {
      // this._vehicleDeployInfoCvCarList();
    },
    methods: {
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        const exportParams = {
          voyageNumber: this.voyageNumber,
          consignorName: this.unitIpt,
          supplierName: this.supplier,
          batchNumber: this.batchIpt,
          waybillNo: this.awbIpt,
          frameNumber: this.chassisIpt,
          brandName: this.brandIpt,
          state: this.stateIpt,
          shipName: this.shipName,
          startPlanDate: this.planDate[0] ? this.planDate[0] : '',
          endPlanDate: this.planDate[1] ? this.planDate[1] : '',
          startLoadingDate: this.loadingDate[0] ? this.loadingDate[0] : '',
          endLoadingDate: this.loadingDate[1] ? this.loadingDate[1] : '',
        };
        window.exportExcel(`${baseUrl}/platform/EntrustedTracking/export?access_token=${token}`, exportParams, '委托车跟踪列表');
      },
      dateFormat(row, column, cellValue) {
        return cellValue.slice(0, 10);
      },
      formatValue(row, column, cellValue) {
        return cellValue ? cellValue : '--';
      },
      // 分页查询
      async _vehicleDeployInfoCvCarList() {
        this.tableLoad = true;
        const { status, message, data } = await vehicleDeployInfoCvCarList({
          voyageNumber: this.voyageNumber,
          consignorName: this.unitIpt,
          supplierName: this.supplier,
          batchNumber: this.batchIpt,
          waybillNo: this.awbIpt,
          frameNumber: this.chassisIpt,
          brandName: this.brandIpt,
          state: this.stateIpt,
          shipName: this.shipName,
          startPlanDate: this.planDate[0] ? this.planDate[0] : '',
          endPlanDate: this.planDate[1] ? this.planDate[1] : '',
          startLoadingDate: this.loadingDate[0] ? this.loadingDate[0] : '',
          endLoadingDate: this.loadingDate[1] ? this.loadingDate[1] : '',
          rows: this.size,
          page: this.page,
        });
        this.tableLoad = false;
        if (status !== 0) return this.$message.warning(message);
        this.TableDatas = data.data;
        this.brand = data.brand;
        this.total = data.total;
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._vehicleDeployInfoCvCarList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._vehicleDeployInfoCvCarList();
      },
      async detailClick(id) {
        this.detailDialogVisible = true;
        const res = await vehicleDeployInfoCvCarDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = {
          ...res.data,
        };
      },
      changeClick() {
        this.dialogTitle = '运输路线地图';
        this.dialogVisible = true;
      },
      searchBtn() {
        const isPlanDateStart = Date.parse(this.planDate[0]);
        const isLoadingDateStart = Date.parse(this.loadingDate[0]);
        if (!isPlanDateStart && !isLoadingDateStart) return  this.$message.warning('请选择计划时间或者装车时间！');
        this.page = 1;
        this._vehicleDeployInfoCvCarList();
      },
      resetBtn() {
        this.voyageNumber = '';
        this.awbIpt = '';
        this.batchIpt = '';
        this.chassisIpt = '';
        this.unitIpt = '';
        this.supplier = '';
        this.brandIpt = '';
        this.stateIpt = '';
        this.shipName = '';
        this.planDate = ['', ''];
        this.loadingDate = ['', ''];
      },
      async routeMapClick(id) {
        this.dialogTitle = '运输路线地图';
        const res = await EntrustedTrackingGetJWtitud(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.lineArr = res.data[res.data.length - 2];
        this.center = this.lineArr[0] ? this.lineArr[0] : [];
        this.dialogVisible = true;
        // this.routerMap.start=res.data.location.start_coordinate.split(',').map(Number);
        // this.routerMap.end=res.data.location.delivery_coordinate.split(',').map(Number);
      },
      transportModeExportFormat(row, column, cellValue) {
        switch (cellValue) {
          case 1:
            return '公路';
          case 2:
            return '水路';
          case 3:
            return '水陆联运';
        }
      },
      // 获取起运地
      getStart(row) {
        if (row.departurePlaceType == 2) {
          if (row.departurePort) {
            return row.departurePlace + '【' + row.departurePort + '】';
          } else {
            return row.departurePlace;
          }
        } else {
          return row.departurePlace || '';
        }
      },
      searchCopyFormat(value, flag) {
        console.log(value);
        // value.clipboardData.getData('Text').split('\n')
        let splitArr = value.clipboardData.getData('Text').replace(/\s/g, ',').split(',');
        splitArr = splitArr.filter(item => item);
        console.log(splitArr);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'batchIpt':
            this.batchIpt = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
          case 'chassisIpt':
            this.chassisIpt = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
          case 'awbIpt':
            this.awbIpt = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
      getEnd(row) {
        if (row.arrivePlaceType == 2) {
          if (row.arrivePort) {
            return row.arrivePlace + '【' + row.arrivePort + '】';
          } else {
            return row.arrivePlace;
          }
        } else {
          return row.arrivePlace || '';
        }
      },
      getActual(row) {
        if (row.actualPortName) {
          return row.actualPositionName + '【' + row.actualPortName + '】';
        } else {
          return row.actualPositionName;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .navContainer p {
        display: inline-block;
        width: 70px;
        text-align: right;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 70vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        .stepContainer {
          margin: 10px 0 10px 20px;

          ::v-deep {
            .el-step__description.is-finish {
              color: #c0c4cc;
            }

            .el-step__description {
              color: #c0c4cc;
            }

            //.is-process{
            //  color: #C0C4CC;
            //}
          }
        }

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .company {
      width: 100%;
      height: 400px;
      padding: 20px 10px;
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-step.is-vertical .el-step__title {
      padding-bottom: 2px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
